export default __webpack_public_path__ + "static/media/15.210d3b59.svg";